"use strict";
/**
 * Copyright (c) 2022, 2026 Joerg Breitbart
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InWasm = InWasm;
let z = (s) => {
    if (Uint8Array.fromBase64)
        return Uint8Array.fromBase64(s);
    if (typeof Buffer !== 'undefined')
        return Buffer.from(s, 'base64');
    const b = atob(s);
    const r = new Uint8Array(b.length);
    for (let i = 0; i < r.length; ++i)
        r[i] = b.charCodeAt(i);
    return r;
};
function InWasm(def) {
    if (def.d) {
        const { t, s, d } = def;
        let b;
        let m;
        const W = WebAssembly;
        if (t === 0 /* OutputType.INSTANCE */) {
            if (s)
                return (e) => new W.Instance(m || (m = new W.Module(b || (b = z(d)))), e);
            return (e) => m
                ? W.instantiate(m, e)
                : W.instantiate(b || (b = z(d)), e).then(r => (m = r.module) && r.instance);
        }
        if (t === 1 /* OutputType.MODULE */) {
            if (s)
                return () => m || (m = new W.Module(b || (b = z(d))));
            return () => m
                ? Promise.resolve(m)
                : W.compile(b || (b = z(d))).then(r => m = r);
        }
        if (s)
            return () => b || (b = z(d));
        return () => Promise.resolve(b || (b = z(d)));
    }
    if (typeof _wasmCtx === 'undefined')
        throw new Error('must run "inwasm"');
    _wasmCtx.add(def);
}
//# sourceMappingURL=index.js.map